export default __webpack_public_path__ + "static/media/Poly.2848d964.svg";